import React from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";

interface RadioOption {
  value: any;
  label: string;
  disabled?: boolean;
}

export interface RadioButtonInputProps {
  value: any[];
  onChange: (values: any[]) => void;
  options: RadioOption[];
  isDisabled?: boolean;
  isSummary?: boolean;
  radioName?: string;
}

export default function RadioButtonInput({
  value,
  onChange,
  options,
  isDisabled = false,
  isSummary = false,
  radioName = "radio",
}: RadioButtonInputProps) {
  return (
    <ButtonGroup
      className="rounded-3 bg-white p-1 border border-secondary-subtle align-items-center"
      style={{ height: 42 }}
    >
      {options.map((opt) => (
        <ToggleButton
          disabled={isDisabled || opt.disabled}
          key={opt.value}
          id={`radio-${opt.value}-${radioName}${isSummary ? "-summary" : ""}`}
          type="radio"
          variant="outline-secondary"
          className="rounded-3 border-0 fw-bold opacity-50 text-xs text-nowrap"
          name={radioName}
          value={opt.value}
          checked={value.includes(opt.value)}
          onClick={() => onChange([opt.value])}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
}
